module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"street":"Street Address","number":"House Number","post":"Postal Code","city":"City","country":"Country"},"sl":{"street":"Ulica","number":"Hišna številka","post":"Poštna številka","city":"Mesto","country":"Država"}}')
  delete Component.options._Ctor
}
